import consumer from './consumer'

class MessagesChannelManager {
  constructor() {
    this.subscription = null
    this.callbacks = new Set()
    this.currentUid = null
  }

  subscribe(authHeaders) {
    if (this.subscription && this.currentUid === authHeaders.uid) {
      return this.subscription
    }

    if (this.subscription) {
      this.unsubscribe()
    }

    this.currentUid = authHeaders.uid
    this.subscription = consumer.subscriptions.create(
      {
        channel: 'MessagesChannel',
        'access-token': authHeaders['access-token'],
        client: authHeaders.client,
        uid: authHeaders.uid
      },
      {
        connected: () => {},

        disconnected: () => {},

        rejected: () => {},

        received: (data) => {
          this.callbacks.forEach((callback) => callback(data))
        }
      }
    )

    return this.subscription
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
      this.currentUid = null
    }
  }

  addCallback(callback) {
    this.callbacks.add(callback)
  }

  removeCallback(callback) {
    this.callbacks.delete(callback)
  }
}

export const messagesChannelManager = new MessagesChannelManager()
export default messagesChannelManager
